export default {
  root: {
    "&:hover,&.MuiListItem-button:hover,&.Mui-selected,&.Mui-selected:hover": {
      backgroundColor: "rgb(97, 166, 245, 0.1)",
      borderRadius: 4,
    },
    "&.nav-link": {
      fontWeight: 600,
    },
    "&.Mui-selected": { color: "#61A6F5", fontWeight: 800 },
  },
};
